@use 'sass:color';
@use "../../scss/util";

/******** FLEX PROPS ********/
.missionBox {
    box-sizing: border-box;
    padding: 40px 20px;
}

.mission {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;

    &PhotoBox { flex: 100% }
    &MessageBox { flex: 100% }
    
    @include util.mq(util.$md) { &MessageBox { flex: 0 0 util.$sm } }
    
    @include util.mq(util.$lg) {
        max-width: 1400px;
        margin: 0 auto;
        
        &PhotoBox { flex: 1 }
        &MessageBox { flex: 1 }
    }
}

.mission {
    &PhotoBox {
        img {
            display: block;
            max-width: 500px;
            height: auto;
            margin: 0 auto;
        }
    }
}

.missionHeading {
    font-size: 2.5em;
    color: util.$eBlueDark;
}

.missionContent {
    font-size: 1.4em;
    line-height: 1.5em;
    color: rgb(86, 86, 86);
    font-weight: 100;
}